import { SxStyles } from '../../../../types';
import theme from '../../../../theme';
import { getResponsiveSize } from '../../../../utils';

export const speedDetailsStyles: SxStyles = {
  speedDetails: {
    height: getResponsiveSize(100),
    display: 'flex',
    justifyContent: 'space-around',
    '& .container': {
      position: 'relative',
      borderRadius: '10px',
      width: 'auto',

      '& .MuiSlider-root': {
        backgroundColor: 'hidden',
        p: 0,
        borderRadius: '10px',
        width: getResponsiveSize(49),
        overflow: 'hidden',
        position: 'relative',
        '& input[type="range"]': {
          color: theme.palette.mainControls?.blueGradient,
          writingMode: 'vertical-lr',
          direction: 'rtl',
        },
        '& .MuiSlider-track': {
          background: theme.palette.mainControls?.blueGradient,
          borderColor: 'transparent',
          border: 'none',
          borderRadius: '6px',
        },
        '& .MuiSlider-rail': {
          background: theme.palette.mainControls?.inActivegrey,
          boxShadow: 'none',
          opacity: 1,
          filter: 'none',
        },
        '& .MuiSlider-thumb': {
          visibility: 'hidden',
          width: '100%',
        },
      },

      '& .value-container': {
        position: 'absolute',
        top: '90%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        pointerEvents: 'none',
        '& .value-container': {
          color: theme.palette.neutral?.white,
          fontSize: theme.typography.fs12,
        },
      },
    },
    '& .controls-container': {
      pl: getResponsiveSize(12),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: 'auto',

      '& .button': {
        height: '100%',
        maxHeight: '42%',
        width: getResponsiveSize(49),
        backgroundColor: theme.palette.mainControls?.mainBlue,
        fontSize: getResponsiveSize(24),
        color: theme.palette.neutral?.white,
        borderRadius: '10px',
        p: getResponsiveSize(12),

        '& svg': {
          fontSize: getResponsiveSize(18),
        },
      },
    },
  },
};
